import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'common/localization';
import SubCategoryMenu from './subcategory-menu';
import { isQueryMatch, respondToQueryMatch } from 'common/util/matchmedia-helper';

function CategoryMenu({ categories, catAmount }) {
  const [focusedMenu, setFocusedMenu] = useState(-1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [itemAmount, setItemAmount] = useState(catAmount || getBreakpointAmount());

  function toggleMobileMenu() {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  function updateFocus(idx) {
    setFocusedMenu(idx);
  }

  function resetMenu() {
    setFocusedMenu(-1);
    setMobileMenuOpen(false);
    resetAmount();
  }

  function resetAmount() {
    setItemAmount(catAmount || getBreakpointAmount());
  }

  function getBreakpointAmount() {
    if (!isQueryMatch('medium')) {
      return categories.length;
    } else {
      const itemAmount = isQueryMatch('large') ? 8 : 6;
      const showAllCats = categories.length === itemAmount + 1;

      return showAllCats ? itemAmount + 1 : itemAmount;
    }
  }

  respondToQueryMatch('medium', resetMenu);
  respondToQueryMatch('large', resetAmount);

  return (
    <nav className="cat-menu qa-menu" aria-label={translate('label.product.type')}>
      <button onClick={toggleMobileMenu} className={`cat-menu__header cat-menu__toggle-btn ${mobileMenuOpen ? 'cat-menu__toggle-btn--open' : ''}`}>{translate('footer.labels.shop.category')}</button>
      <ul className={`cat-menu__list js-menu-container ${mobileMenuOpen ? 'cat-menu__list--open' : ''}`}>
        {categories.map((cat, idx) => {
          if (idx < itemAmount) {
            return (
              <SubCategoryMenu onFocusChange={updateFocus} menuItem={idx} isOpen={focusedMenu === idx} key={`cat-${idx}`} subcategories={cat.childCategories} name={cat.name} url={cat.seoUrlToken} />
            );
          }
        })}

        { categories.length > itemAmount &&
          <SubCategoryMenu onFocusChange={updateFocus} menuItem={itemAmount} isOpen={focusedMenu === itemAmount} subcategories={categories.slice(itemAmount)} name={translate('header.navigation.category.more')} />
        }
      </ul>
    </nav>
  );
}

CategoryMenu.propTypes = {
  catAmount: PropTypes.number,
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    seoUrlToken: PropTypes.string.isRequired,
    childCategories: PropTypes.array,
  })).isRequired,
};

export default CategoryMenu;
